// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const workWithUsData = createApi({
  reducerPath: "workWithUsApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),
  endpoints: (builder) => ({
    addBusinessPartner: builder.mutation({
      query: (body) => ({
        url: `add_business_partner`,
        method: "POST",
        body,
      }),

      transformResponse: (response, meta, arg) => response.data,
    }),
    addCareer: builder.mutation({
      query: (body) => ({
        url: `add_career`,
        method: "POST",
        body,
      }),

      transformResponse: (response, meta, arg) => response.data,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useAddBusinessPartnerMutation, useAddCareerMutation } =
  workWithUsData;
